import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfSection from '@elem/ui/ef-section';

export default function TheComp() {
    const { t } = useLang('rapid.SectionA');
    return (
        <div className={css.comp}>
            <EfSection
                position="hover"
                pc="https://websiteoss.ecoflow.com/upload/image/1729597983399/pc_low%20temp.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1729597983223/m_low%20temp.jpg"
                title={t('title')}
                desc={t.rich('desc', {
                    text1: (text: string) => <span className="desc-color-2">{text}</span>,
                })}
            />
        </div>
    );
}
